import React from "react";
import ReactDOM from "react-dom";
import App from "./App_calc";
import { createStore } from "redux";
import rootReducer from "./reducers/reducer";
import { Provider } from "react-redux";
//console.log("src/index.js");

const store = createStore(rootReducer);

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
